// toggle switch directive
//
// example:
//   <p ng-init="checkedState = true">
//     Toggle
//     <toggle-switch ng-model="checkedState" color="blue"></toggle-switch>
//     Checked: '{{checkedState}}'
//   </p>
//
// note:
//  * `color` value must match the CSS options in app/styles/components/_toggle_switch.scss

let module = angular.module('app.directives');

const DEFAULT_COLOR = 'green';

module.directive('toggleSwitch', function () {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      ngChange: '&',
      color: '@',
      label: '@',
    },
    require: 'ngModel',
    template: `
      <label style="line-height: 24px">
        <span class="toggle-switch toggle-switch--{{::color}}">
          <input type="checkbox" ng-model="ngModel" ng-change="ngChange($event)">
          <span class="slider"></span>
        </span>
        <span ng-if="label" style="display: inline-block; margin-left: 5px;">{{label}}</span>
      </label>
    `,
    link: function (scope, element, attrs, ngModelCtrl) {
      scope.color = scope.color || DEFAULT_COLOR;
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/toggle-switch.js